import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatAssistanceService } from '@commons/chat-assistance/chat-assistance.service';
import { IChatGuest } from '@commons/chat-assistance/models/chat-guest';

import { UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-list',
  templateUrl: 'chat-list.component.html',
  styleUrls: ['./chat-list.component.scss'],
})
export class ChatListComponent implements OnInit {
  @Input()
  roomid: string;

  selectedGuest: IChatGuest;
  selectedGuests: IChatGuest[] = [];

  @Output()
  onNewRoom: EventEmitter<any> = new EventEmitter();

  @Output()
  onLeaveConferenceList: EventEmitter<any> = new EventEmitter();

  private guestsDirectory: any[] = [];

  constructor(private readonly chatAssistanceService: ChatAssistanceService) {}

  get availableGuests() {
    return this.guestsDirectory;
  }

  get selected() {
    return this.selectedGuest;
  }

  ngOnInit(): void {
    this.chatAssistanceService.getGuestsDirectory().subscribe(directory => {
      this.guestsDirectory = directory;
      this.updateGuestStatus();
    });

    // when receiving new message and chat is flipped, hide it
    this.chatAssistanceService
      .message$()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        if (this.chatAssistanceService.isFlipped) {
          this.closeList();
        }
      });
  }

  updateSelectedList(guest) {
    const idx = this.selectedGuests.indexOf(guest);
    if (idx > -1) {
      this.selectedGuests.splice(idx, 1);
    } else {
      this.selectedGuests.push(guest);
    }
  }

  addNewRoom() {
    if (this.roomid) {
      let currentGuests: IChatGuest[] = this.chatAssistanceService.getGuests(this.roomid);
      // made it now because selectedGuests will be updated
      this.chatAssistanceService.notifyGuestsAdded(this.roomid, currentGuests, this.selectedGuests);
      this.selectedGuests.forEach(g => {
        this.addGuest(g);
      });
      this.onLeaveConferenceList.emit();
    } else {
      this.onNewRoom.emit(this.selectedGuest);
    }

    ($('#card') as any).flip('toggle');
    this.chatAssistanceService.isFlipped = !this.chatAssistanceService.isFlipped;
  }

  addGuest(guest: IChatGuest): void {
    if (guest) {
      this.chatAssistanceService.addGuest(this.roomid, guest);
      this.selectedGuests = [];
    }
  }

  closeList() {
    ($('#card') as any).flip('toggle');
    this.chatAssistanceService.isFlipped = !this.chatAssistanceService.isFlipped;
    this.onLeaveConferenceList.emit();
  }

  private updateGuestStatus() {
    let rooms = this.chatAssistanceService.getRooms();
    let selectedGuestIds: any[] = [];
    rooms.forEach(r => {
      r.toGuests.forEach(e => {
        selectedGuestIds.push(e.id);
      });
    });

    this.guestsDirectory.forEach(e => {
      if (selectedGuestIds.indexOf(e.userId) > -1) {
        e.isOngoing = true;
      }
    });
    this.guestsDirectory = this.guestsDirectory.filter(e => e.isPresent);
  }
}
